import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';

import RITabContent from './relevantInfo/RITabContent';
import { MentionsInput, DateRangeSelector } from '../../../../components/form';

function RelevantInfo(props){
    const mounted = useRef(false);
    useEffect(() => {
        mounted.current = true;
        return () => (mounted.current = false);
    });

    const [searchTerm, setSearchTerm] = useState('');
    const lastSearchTermFromParent = useRef('');

    const { parentApiError, relInfo, formik, refreshRelInfo, tagsData, searchTermFromParent } = props;

    // Sync searchTermFromParent to searchTerm (only when it changes)
    // Don't sync if field is empty and parent is also empty (prevents unwanted updates)
    useEffect(() => {
        if (searchTermFromParent && searchTermFromParent !== lastSearchTermFromParent.current) {
            // Only update if the new value is different from current
            setSearchTerm(current => {
                if (current !== searchTermFromParent) {
                    lastSearchTermFromParent.current = searchTermFromParent;
                    return searchTermFromParent;
                }
                return current;
            });
        } else if (!searchTermFromParent && lastSearchTermFromParent.current) {
            // Parent cleared it - clear our state too
            setSearchTerm('');
            lastSearchTermFromParent.current = '';
        }
    }, [searchTermFromParent]);

    return (
        <div>
            <h2>Relvant Info Search</h2>

            <br/>

            <DateRangeSelector
                id="relevant-info-drs"
                startName="startDate"
                endName="endDate"
                startLabel="Start Date"
                endLabel="End Date"
                startValue={formik.values.startDate}
                endValue={formik.values.endDate}
                defaultValid={true}
                onStartChange={formik.handleChange}
                onEndChange={formik.handleChange}
            />

            <br/>

            <MentionsInput
                id="relevantInfoSearch"
                name="searchTerm"
                tags={tagsData}
                value={searchTerm || ''}
                onChange={(e) => {
                    const newValue = e.target.value;
                    setSearchTerm(newValue);
                    
                    // Check if value contains multiple student name patterns (concatenation issue - field getting stuck)
                    const matches = newValue.match(/!~([^~]+)~!/g);
                    if (matches && matches.length > 1) {
                        // Multiple patterns found - use the last one (most recent selection)
                        const lastMatch = matches[matches.length - 1];
                        const studentMatch = lastMatch.match(/!~([^~]+)~!/);
                        if (studentMatch && studentMatch[1]) {
                            const formattedValue = `!~${studentMatch[1]}~!`;
                            setSearchTerm(formattedValue);
                            lastSearchTermFromParent.current = formattedValue; // Update ref to prevent parent from overwriting
                            refreshRelInfo(studentMatch[1]);
                            return;
                        }
                    }
                    
                    // Single pattern - trigger search only if complete pattern
                    const match = newValue.match(/^!~([^~]+)~!$/);
                    if (match && match[1]) {
                        lastSearchTermFromParent.current = newValue; // Update ref to prevent parent from overwriting
                        refreshRelInfo(match[1]);
                    }
                }}
                updateLastTagged={(item) => {
                    const studentName = item.value;
                    const formattedValue = `!~${studentName}~!`;
                    setSearchTerm(formattedValue);
                    lastSearchTermFromParent.current = formattedValue; // Update ref to prevent parent from overwriting
                    refreshRelInfo(studentName);
                }}
                triggerKeyCode={50}
                shiftKey={true}
                placeholder="Type @ to search for a user. Select an item to search."
            />
            <br/>
            {parentApiError ? <div className="text-mpLRed">{parentApiError}</div> :
            Object.keys(relInfo).length ?
                <RITabContent
                    relInfo={relInfo}
                />
                : null
            }
        </div>
    );
}

export default connect(null, {

})(RelevantInfo);
